import React, { Fragment, useContext } from "react";
import aws from "../../../../config/aws";
import { Card } from "antd";
import { Link } from "react-router-dom";
import "./card_producto.scss";
import { MenuContext } from "../../../../context/carritoContext";
import { makeStyles } from "@material-ui/styles";
import {
  agregarPorcentaje,
  formatoMexico,
} from "../../../../config/reuserFunction";

const gridStyle = { width: "100%", padding: 0, marginBottom: "1.5rem" };

export default function Card_Producto(props) {
  const { productos } = props;
  const { colores } = useContext(MenuContext);

  const useStyles = makeStyles({
    background: {
      backgroundColor: colores.bodyPage.card.background,
      border: "none",
      "& .text-color": {
        color: colores.bodyPage.card.text,
      },
    },
  });
  const classes = useStyles();

  return (
    <Fragment>
      <div>
        <Link to={`/vista_producto/${productos._id}`}>
          <Card.Grid
            hoverable
            style={gridStyle}
            className={
              "contenedor-card-producto-principal " + classes.background
            }
          >
            <Card
              className={"contenedor-card-body " + classes.background}
              cover={
                <div className="contenedor-imagen-oferta">
                  {productos.promocion && productos.promocion.length > 0 ? (
                    <div className="oferta-frente">
                      <h5 className="shadow">OFERTA</h5>
                      <p>
                        -
                        {agregarPorcentaje(
                          productos.promocion[0].precioPromocion,
                          productos.precio
                        )}
                        %
                      </p>
                    </div>
                  ) : null}

                  <div className="contenedor-imagen-principal">
                    <img
                      className="imagen-principal"
                      alt="producto"
                      src={aws + productos.imagen}
                    />
                  </div>
                </div>
              }
            >
              {productos.precio ? (
                <div className="container">
                  <div style={{ marginTop: "8px" }}>
                    <h4 className=" titulo-elipsis">{productos.nombre}</h4>
                  </div>

                  <div className="d-flex justify-content-end">
                    {!productos.promocion.length ? (
                      <h3 className="font-prin precio-rebaja ">
                        ${formatoMexico(productos.precio)}
                      </h3>
                    ) : (
                      <div className="cont-precios-frente ">
                        <div>
                          <h2 className="font-peque precio-producto mr-2 mb-0">
                            ${formatoMexico(productos.precio)}
                          </h2>
                          <h3 className="font-prin precio-rebaja d-inline mr-1">
                            $
                            {formatoMexico(
                              productos.promocion[0].precioPromocion
                            )}
                          </h3>
                        </div>
                        <p className="font-peque porcentaje-descuento d-inline">
                          -
                          {agregarPorcentaje(
                            productos.promocion[0].precioPromocion,
                            productos.precio
                          )}
                          %
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div className="m-1" >
                    <h4>{productos.nombre}</h4>
                  </div>
              )}
            </Card>
          </Card.Grid>
        </Link>
      </div>
    </Fragment>
  );
}
